import React from 'react';

import { roundXDisplay, ratioToPercentPlus } from '../../lib/format';

export const BoldFormatter = ({ value }) => {
  return <span className="s-stats--formatter-bold">{value}</span>;
};

export const RoundingFormatter = ({ value }) => {
  let x = 1;
  if (value % 1 === 0) {
    return value;
  }
  if (value < 1) x = 3;
  return (
    <span className="s-stats--formatter-rounding">
      {roundXDisplay(value, x)}
    </span>
  );
};

export const PercentFormatter = ({ value }) => {
  return (
    <span className="s-stats--formatter-percentage">
      {ratioToPercentPlus(value, 2)}
    </span>
  );
};
